import React, { createContext, useContext, useMemo } from 'react';

import { getStorageModeFlags, STORAGE_MODES } from '@utils/storageMode';

const StorageModeContext = createContext(null);

/**
 * StorageModeProvider — operator 當前 warehouse 的 storage_mode gating context。
 *
 * @param {string} mode - 'dynamic' | 'virtual' | 'dedicated'；undefined / null 時 fallback 為 'dynamic'
 *                        （與 Rails enum default 一致）
 */
export function StorageModeProvider({ mode: modeProp, children }) {
  const value = useMemo(() => {
    const mode = modeProp || STORAGE_MODES.DYNAMIC;
    return { mode, ...getStorageModeFlags(mode) };
  }, [modeProp]);

  return <StorageModeContext.Provider value={value}>{children}</StorageModeContext.Provider>;
}

export function useStorageMode() {
  const ctx = useContext(StorageModeContext);
  if (!ctx) throw new Error('useStorageMode must be used within StorageModeProvider');
  return ctx;
}

export const useIsDynamic = () => useStorageMode().isDynamic;
export const useIsVirtual = () => useStorageMode().isVirtual;
export const useIsDedicated = () => useStorageMode().isDedicated;

export default StorageModeContext;
